import React from 'react';
import {NavLink, Link} from "react-router-dom";
import logo from '../../assets/images/header/cmx-logo.svg';
import cmx_cinebistro from '../../assets/images/header/cmx-cinebistro.svg';
import footer_logo from '../../assets/images/footer/footer-logo.png';
import influx from '../../assets/images/footer/influx-logo.png';
import mobile_menu from '../../assets/images/header/mobile-menu.png';
import profile from '../../assets/images/icons/profile.png';
import within_profile from '../../assets/images/icons/after-login-profile.png';

class Header extends React.Component {
  render() {
    return (
      <header className="fixed-top" ref={this.props.headerHeight}>
        
        {/* <section className="settings-wrap">
          {
            this.props.state.homeSettingsAPI.length > 0 && Object.keys(this.props.state.homeSettingsAPI[0].configs).length > 0 && !this.props.state.homeSettingsAPI[0].configs.subscriptionEnabled ?
            <section className='settings-inner'>
              <aside className="lft">
                <h5>Important Update!</h5>
              </aside>
              <aside className='rgt'>
                <p>{this.props.state.homeSettingsAPI[0].configs.description}</p>
              </aside>
              {/* <a href="javascript:;" className="close-icon" title="Close">&nbsp;</a> *`/}
            </section>
            :null
          }
        </section> */}

        <section className={`cmx-flex-header ${this.props.state.mobileMenu_SH ? 'show':''}`}>
          <section className="header-blk">
            {/* <aside className="logo d-inline-block">
                <figure>
                    <a onClick={this.props.h_goHome} href='javascript:;' title='PASSPORT BY CMX'>
                      <img src={logo} alt="PASSPORT BY CMX" className="img-fluid" />
                    </a>
                </figure>
            </aside> */}
            <aside className='header-rgt text-center'>
              <ul className='cmx-cinemas'>
                <li className='d-inline-block align-top'>
                  <a onClick={this.props.CMXCinemalogo} className='d-block' href="javascript:;" title='CMX CINEMAS | CINEBISTRO'>
                    <img src={cmx_cinebistro} alt="CMX CINEMAS | CINEBISTRO" className="img-fluid" />
                  </a>
                </li>
              </ul>
              <ul className='static-content'>
                {/* {
                  this.props.state.header_homeSH && 
                  <li className='d-inline-block align-bottom'>
                    <a href="https://www.cmxcinemas.com/" target="_blank" title='Home'><span>Home</span></a>
                  </li>
                } */}
                <li className='d-inline-block align-bottom'>
                  <Link exact to={"/faq"} title='FAQ(s)'><span>FAQ(s)</span></Link>
                </li>
                <li className='d-inline-block align-bottom'>
                  <a onClick={(e) => this.props.TandC_componentClick(e, 'header')} href="javascript:;" title='Terms &amp; Conditions'><span>Terms &amp; Conditions</span></a>
                  {/* <Link onClick={(e) => this.props.TandC_componentClick(e, 'header')} exact to={"/terms-conditions"} title='Terms &amp; Conditions'><span>Terms &amp; Conditions</span></Link> */}
                </li>
                {/* <li className='d-inline-block align-bottom'><a href="javascript:;" title='Sign-In'>Sign-In</a></li> */}
                {/* <li className='d-inline-block align-bottom al-design-blk'>
                  <a href="javascript:;" title='Hi, Alejandro Elliott'>
                    <span className='d-inline-block align-middle'>Hi, <strong>Alejandro Elliott</strong></span>
                  </a>
                  <figure className='d-inline-block align-bottom'><img src={within_profile} alt='Hi, Alejandro Elliott'></img></figure>
                  <section className='profile-hover-blk'>
                    <h6>Alejandro Elliott</h6>
                    <aside className='list-blk'>
                      <ul className='position-relative'>
                        <li><a href="javascript:;" title='My profile'>My profile</a></li>
                        <li><a href="javascript:;" title='Booking history'>Booking history</a></li>
                        <li><a href="javascript:;" title='Logout'>Logout</a></li>
                      </ul>
                    </aside>
                  </section>
                </li> */}
              </ul>
            </aside>
            <section className='menu-icon text-end'>
              <a onClick={this.props.h_menu} className='mobile-menu-btn' href='javascript:;' title='Menu'>
                <img src={mobile_menu} alt="CMX Passport" className="img-fluid" />
              </a>
            </section>
            <section className="mobile-menu-blk">
              {/* <section className='top-banner'>
                <section className='without-login'>
                  <p className='already'>Already a registered CMX Member?</p>
                  <aside className='cmx-flex-btn-group text-start'>
                    <a onClick={this.props.mobileSignInBtn} className='flex-btn' href='javascript:;' title='SIGN IN'><span>Sign in</span></a>
                  </aside>
                  <p className='register'>New to CMX? <a onClick={this.props.mobileRegisterNowBtn} href='javascript:;' title='Register now'>Register now</a></p>
                </section>
                <section className='with-login'>
                  <aside className='lft d-inline-block align-middle'>
                    <figure>
                      <img src={profile} alt="CMX Passport" className="img-fluid" />
                    </figure>
                  </aside>
                  <aside className='rgt d-inline-block align-middle'>
                    <p className='ps-3'>Hi, <span className='d-block'>Alejandro Elliott</span></p>
                  </aside>
                </section>
                <a onClick={this.props.h_closeBtn} className='close-btn' href='javascript:;' title='Close'>&nbsp;</a>
              </section> */}
              {/* <section className='login-details-blk'>
                <ul>
                  <li><a className='acc' href="javascript:;" title='My Account'>My Account</a></li>
                  <li><a className='edit' href="javascript:;" title='Edit Profile'>Edit Profile</a></li>
                  <li><a className='member' href="javascript:;" title='Membership'>Membership</a></li>
                </ul>
              </section> */}
              <section className='list-blk'>
                <a onClick={this.props.h_closeBtn} className='close-btn' href='javascript:;' title='Close'>&nbsp;</a>
                <ul>
                  {/* {
                    this.props.state.header_homeSH && 
                    <li>
                      <a href="https://www.cmxcinemas.com/" target="_blank" title='Home'><span>Home</span></a>
                    </li>
                  } */}
                  <li className='d-inline-block align-top'>
                    <a onClick={this.props.CMXCinemalogo} style={{width:'100px'}} className='d-block pb-2' href="javascript:;" title='CMX CINEMAS | CINEBISTRO'>
                      <img src={cmx_cinebistro} alt="CMX CINEMAS | CINEBISTRO" className="img-fluid" />
                    </a>
                  </li>
                  <li>
                    <Link onClick={this.props.mobFaqClick} exact to={"/faq"} title='FAQs'><span>FAQs</span></Link>
                  </li>
                  {/* <li><a href='javascript:;' title='Support Centre'>Support Centre</a></li> */}
                  <li>
                    {/* <a href='javascript:;' title='Terms &amp; Conditions'>Terms &amp; Conditions</a> */}
                    <a onClick={(e) => this.props.TandC_componentClick(e, 'header')} href="javascript:;" title='Terms &amp; Conditions'><span>Terms &amp; Conditions</span></a>
                    {/* <Link onClick={this.props.mobFaqClick} exact to={"/terms-conditions"} title='Terms &amp; Conditions'><span>Terms &amp; Conditions</span></Link> */}
                  </li>
                  {/* <li><a href='javascript:;' title='Sign Out'>Sign Out</a></li> */}
                </ul>
              </section>
              {/* Footer > start */}
              {/* <section className='btm-footer-blk'>
                <figure>
                  <img src={footer_logo} alt="CMX Passport" className="img-fluid" />
                </figure>
                <aside className='btm'>
                    <aside className='lft text-start'>
                      <p>© 2022 CMX Cinemas</p>
                    </aside>
                    <aside className='rgt text-end'>
                      <figure className='d-inline-block align-middle pb-0 pb-2'>
                        <p className='d-inline-block align-middle'>Powered by</p>
                        <a className='d-inline-block align-middle btm-img' href='https://myinfinity.co/direct/' target="_blank" title='influx'><img src={influx} alt="CMX Passport" className="img-fluid" /></a>
                      </figure>
                    </aside>
                </aside>
              </section> */}
              {/* Footer > end */}
            </section>
          </section>
        </section>
      </header>
    )
  }
}

export default Header;
